module.exports = __webpack_public_path__ + "static/media/logo.244d9fa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/logo.png
// module id = 263
// module chunks = 0